import useScreenSize from './useScreenSize'

export default function useIsMobile() {
  const screenSize = useScreenSize()

  return screenSize === 'mobile'
}
